import type { Board } from "../board";
import type { Direction } from "../direction";
import { directionDelta } from "../direction";
import { MovementEffect } from "../effects/movementEffect";
import type { Player } from "../player";
import { GasBomb } from "../projectiles/gasBomb";
import { Sound } from "../things/sounds/sound";
import { SoundId } from "../things/sounds/soundId";
import { Weapon } from "../weapon";
import { WeaponVisual } from "../weaponVisual";

export class GasBombWeapon extends Weapon {
	static key = "GasBombWeapon";
	constructor(owner: Player, ammo: number = 5) {
		super(owner, ammo);
	}

	override getWeaponVisual(): WeaponVisual {
		return WeaponVisual.GRENADE;
	}

	fire(direction: Direction, board: Board): void {
		board.addNonPhysicalThing(new Sound(SoundId.SHOT_THROW));
		let targetXY = this.owner.xy.add(directionDelta(direction));
		if (GasBomb.collisionCheck(board, targetXY)) {
			targetXY = this.owner.xy;
		}
		if (!board.isInBounds(targetXY)) return;
		const gasBomb = new GasBomb(targetXY, direction);
		board.addThing(gasBomb);
		if (!targetXY.equals(this.owner.xy)) {
			board.addEffect(new MovementEffect(gasBomb, this.owner.xy, targetXY));
		}
	}

	static deserialize(data: any, owner: Player): GasBombWeapon {
		const gun = new GasBombWeapon(owner);
		gun.ammo = data.ammo;
		return gun;
	}
}
